<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <spinner v-if="activateSpinner"></spinner>
        <b-row v-else class="justify-content-center align-items-center">
          <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
            <span class="mb-3">
              <i>
                {{ listItemsGlobalConfig.length > 0 && listItemsGlobalConfig[0].Value == 1
                  ? $t('common.global_config.value_non_missing')
                  : $t('common.global_config.value_missing')
                }}
              </i>
            </span>
            <b-form-checkbox v-model="Value" :checked="listItemsGlobalConfig.length > 0 && listItemsGlobalConfig[0].Value == 1">
              <span>{{ $t('common.global_config.parameter_GDR') }}</span>
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="justify-content-end">
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('details')">
              <span>{{ $t('common.cncl') }}</span>
            </b-button>
          </b-col>
          <!-- <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('edit')">
              <i class="fa-light fa-pencil"></i>
              <span>{{ $t('administration.edit') }}</span>
            </b-button>
          </b-col> -->
          <b-col cols="4" lg="2" xl="1" v-if="formType !== 'add'">
            <b-button variant="primary"
              @click="editGlobalConfig">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="formType === 'add'">
            <b-button variant="primary"
              @click="addGlobalConfig">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import Spinner from '@/components/common/spinner.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: "GlobalConfigPage",
  components: {
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.global_config')
        case 'details':
          return this.$t('Webheader.global_config')
        case 'add':
        default:
          return this.$t('Webheader.global_config')
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      Value: false,
      currentGlobalConfig: {},
      listItemsGlobalConfig: [],
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode
    this.getGlobalConfig()

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getGlobalConfig()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addGlobalConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Name: 'GDR',
        Value: this.Value === true ? 1 : 0
      }
      this.$engine.globalConfig.addGlobalConfig(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.global_config.parameter_GDR_enabled'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        this.getGlobalConfig()
        loadPage(that, {url: '/globalConfig/'})
      })
      .catch((e) => {
        errorMessageAlert(e, that)
      })
    },
    editGlobalConfig () {
      let that = this
      let params = {
        Name: 'GDR',
        Value: this.Value === true ? 1 : 0
      }

      this.$engine.globalConfig.editGlobalConfig(params)
      .then(resp => {
        let message = this.Value ?
          that.$t('common.global_config.parameter_GDR_enabled') :
          that.$t('common.global_config.parameter_GDR_disabled')

        that.$f7.modal({
          title: message,
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        this.getGlobalConfig()
        loadPage(that, {url: '/globalConfig/'})
      })
      .catch((e) => {
        errorMessageAlert(e, that)
      })
    },
    fillFields () {
      this.config = this.currentGlobalConfig
      this.originalConfig = this.currentGlobalConfig
      this.activateSpinner = false
    },
    formHasError () {
      if (this.Value === false) {
        this.okMessageBox(this.$t('common.global_config.value_missing'))
        return true
      }
      return false
    },
    getGlobalConfig () {
      let that = this
      let params = {
        Name: 'GDR',
      }
      this.$engine.globalConfig.getGlobalConfig(params)
      .then(resp => {
        let that = this
        let globalConfigList = {}

        globalConfigList = resp.data.GlobalConfig || []

        that.updateGlobalConfig(globalConfigList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateGlobalConfig(globalConfigList) {
      this.listItemsGlobalConfig = globalConfigList || []
      this.Value = this.listItemsGlobalConfig.length > 0 && this.listItemsGlobalConfig[0].Value == 1
      if (this.listItemsGlobalConfig.length > 0 && this.listItemsGlobalConfig[0].Name === 'GDR') {
        this.formType = 'details'
      } else {
        this.formType = 'add'
      }
      this.fillFields()
    }
  }
}
</script>
